import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getReferralsByUserId } from '@hotjar/webapp/domains/acquisition/referrals';
import type { Referrals } from '@hotjar/webapp/domains/acquisition/referrals/types';

export const useUserReferrals = (userId?: string): UseQueryResult<Referrals, Error> => {
  return useQuery('userReferrals', () => getReferralsByUserId(userId as string), {
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!userId,
  });
};
